import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Women from "../../Home/components/category/Women";
import Community from "../../Home/components/category/Community";
import Disability from "../../Home/components/category/Disability";
import Transparency from "../../Home/components/category/Transparency";
import Corporate from "../../Home/components/category/Corporate";
import Activism from "../../Home/components/category/Activism";
import Civic from "./category/Civic";
import Inclusion from "./category/Inclusion";
import HallOfFame from "./category/HallOfFame";
import Solution from "./category/Solution";
import Climate from "./category/Climate";
import Health from "./category/Health";

const Categories = () => {
  return (
    <Grid
      container
      alignItems={"center"}
      padding={{ xs: "25% 0%", sm: "3% 0%" }}
    >
      <Grid item xs={12} md={12}>
        <Typography
          variant={"h5"}
          fontWeight={700}
          textAlign={"left"}
          color={"#fff"}
        >
          Nomination for 2026 Active Citizens’ Awards is now open.
        </Typography>
        <Typography
          variant={"body1"}
          paddingTop={{ xs: "10%", sm: "2%" }}
          fontWeight={700}
          textAlign={"left"}
          color={"#fff"}
        >
          N.B: Your nomination is a recommendation, and our team will conduct
          further research to verify the person's work and credibility for the
          category before they can make the shortlist.
        </Typography>

        <Typography
          variant={"body2"}
          fontWeight={500}
          color={"#fff"}
          padding={{ xs: "7% 0%", sm: "2% 0%" }}
          textAlign={"left"}
        >
          Flip each award to view more information
        </Typography>
      </Grid>
      <Women />
      <Community />
      <Disability />
      <Solution />
      <Civic />
      <Climate />
      <Health />
      <Transparency />
      <Corporate />
      <Activism />
      <Inclusion />
      <HallOfFame />
    </Grid>
  );
};

export default Categories;
